<td class="pl-20 pr-20">
    <div class="notification-title d-flex cursor-pointer" data-toggle="collapse" [ngClass]="{ active: showDescription }"><span class="d-inline-block mr-1 collapse-chevron collapse-chevron-small" (click)="toggleShowDescription()"></span><span>{{ progress().title }}</span></div>
  <div *ngIf="showDescription" class="text-gray-50">{{ progress().description }}</div>
</td>
